export const transition = { 
    duration: .25, 
    ease: [.56, .03, .12, 1.04]
};

export const tabVariants = { 
    inactive: {
        color: '#888',
        // backgroundColor: '#f8f9fa'
    }, 
    active: {
        color: '#161d2d',
        // backgroundColor: '#e1e6f0'
    },
    hover: {
        color: '#444'
    }
};

export const containerVariants = {
    initial: {
        opacity: 0,
    },
    animate: {
        opacity: 1
    }
};

export const iconVariants = {
    inactive: {
        opacity: 0,
        y: '-1rem'
    },
    active: {
        opacity: 1,
        y: 0
    }
};

export const lineVariants = {
    inactive: {
        width: 0
    },
    active: {
        width: '50%'
    }
}
